export default "__VITE_ASSET__Cejg$63X__"